<app-sport-team-banner [fleet]="fleetWeekly.fleet" *ngIf="fleetWeekly?.fleet">
  <div class="cre-wig-fleet-banner-container">
    <app-sport-team-logo [circleFrame]="true" [fleet]="fleetWeekly.fleet"></app-sport-team-logo>
    <div>
      <div class="cre-wig-fleet-banner-title">Fleet {{ fleetWeekly.fleet }}</div>
      <app-fleet-competition-results [fleet]="fleetWeekly.fleet"></app-fleet-competition-results>
      <ng-container *ngIf="leagueRanking?.leagueRank != null">
        <span> | Rank: {{ leagueRanking?.leagueRank }} out of {{ leagueRanking?.teamCount }}</span>
      </ng-container>
      <ng-container *ngIf="leagueRanking?.leagueRank == null">
        <span> | Not ranked</span>
      </ng-container>
    </div>
  </div>
</app-sport-team-banner>
